import {
  CMP_COLOR_UI_TAG_SELECTED_SURFACE_FILL_DEFAULT_LIGHT,
  SYS_COLOR_FOREGROUND_NEUTRAL_500_LIGHT,
  SYS_COLOR_SURFACE_NEUTRAL_600_LIGHT,
  SYS_COLOR_SURFACE_NEUTRAL_800_LIGHT,
  SYS_SPACE_FIXED_100,
  SYS_SPACE_FIXED_350,
} from '@oneaudi/unified-web-common';
import styled from 'styled-components';

export const FilterWrapper = styled.div`
  margin-inline: var(--page-margin);
  margin-bottom: ${SYS_SPACE_FIXED_350};
`;

export const MobileFilterContainer = styled.div`
  @media (min-width: ${(props) => props.theme.breakpoints.md}px) {
    width: 30%;
  }
`;

export const TagGroupContainer = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: ${SYS_SPACE_FIXED_100};
`;

export const TagContainer = styled.div`
  cursor: pointer;
  border: 1px solid ${SYS_COLOR_FOREGROUND_NEUTRAL_500_LIGHT};
  display: flex;
  align-self: flex-start;
  flex-wrap: wrap;
  padding: var(--spacing-relative-xs) var(--spacing-relative-sm);

  &.active {
    background: ${CMP_COLOR_UI_TAG_SELECTED_SURFACE_FILL_DEFAULT_LIGHT};
    border: 1px solid ${SYS_COLOR_SURFACE_NEUTRAL_800_LIGHT};
  }
  &.disabled {
    background: ${SYS_COLOR_SURFACE_NEUTRAL_800_LIGHT};
    border: 1px solid ${SYS_COLOR_SURFACE_NEUTRAL_800_LIGHT};
    p {
      color: ${SYS_COLOR_SURFACE_NEUTRAL_600_LIGHT} !important;
    }
  }
`;

export const ContentWrapper = styled.div`
  display: flex;
  align-self: flex-start;
  flex-wrap: wrap;
`;
